import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT_FORM_INITIAL = {
  name: "",
  email: "",
  subject: "",
  destination: "",
  message: "",
};

const FALLBACK_ERROR =
  "We couldn't send your message. Please try again or email us directly.";

function extractError(err) {
  const d = err?.response?.data?.detail;
  return typeof d === "string" ? d : FALLBACK_ERROR;
}

// Encapsulates all stateful behaviour of the contact form so the JSX
// component stays purely presentational.
export default function useContactForm() {
  const [form, setForm] = useState(CONTACT_FORM_INITIAL);
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const update = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");
    try {
      await axios.post(`${API}/inquiries`, form);
      setStatus("success");
      setForm(CONTACT_FORM_INITIAL);
    } catch (err) {
      setStatus("error");
      setErrorMsg(extractError(err));
    }
  };

  return { form, status, errorMsg, update, submit };
}
